import Alpine from "alpinejs";
import lenis from "./smoothScroll";

window.cookieStorage = {
    getItem(key) {
        let cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].split("=");
            if (key == cookie[0].trim()) {
                return decodeURIComponent(cookie[1]);
            }
        }
        return null;
    },
    setItem(key, value) {
        document.cookie = key+' = '+encodeURIComponent(value)
    }
}

function baseApp({
    subMenu
}){
	return{
		menu: false,
		searchBarOpen: false,
		search: false,
        subMenu:subMenu,
        atTop: false,
        lastScrollPos: 0,
        isNavVisible: true,
        closeAlert: this.$persist(false).using(cookieStorage),
        init(){
           lenis.on('scroll', (e) => {
            const currentScrollPos = e.scroll;
                if (currentScrollPos > this.lastScrollPos && currentScrollPos > 200) {
                    this.isNavVisible = false;
                } else {
                    this.isNavVisible = true;
                }
                this.lastScrollPos = currentScrollPos;
            });

            //watch on searchBar open
            this.$watch('searchBarOpen',(value)=>{
                if(value == true){
                    this.$refs.input.focus();
                    lenis.scrollTo(0);
                }
            })
            // Watch on sidemenu open
            this.$watch("menu", (value)=>{
                if(value == true){
                 lenis.stop()
                }else{
                  lenis.start();
                }
            })
        },
	}
};


document.addEventListener("alpine:init", () => {
	Alpine.data('baseApp', baseApp)
})
